import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, mergeMap } from 'rxjs/operators';
import { map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '../../../../environments/environment';
import { NoticesService } from '../notices/notices.service';

@Injectable({
  providedIn: 'root'
})
export class ScreenHandlerService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly noticesService = inject(NoticesService);

  public readonly isModalPage = signal(false);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => this.getLastRouteFirstChild(route)),
        mergeMap((route) => route.data),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((currentValue) => {
        this.noticesService.closeAll();
        this.isModalPage.set(currentValue?.modal ?? false);
      });

    if (!['PRO', 'PRE'].includes(environment.environment)) {
      document.getElementsByTagName('body')[0].classList.add('dev');
    }
  }

  private getLastRouteFirstChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
